// datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, sektor, opis, tags, dodeljen user
export class BaseDocument {
	indexingNumber: string
	indexingDate: string
	documentNumber: string
	documentDate: string
	sectorId: string
	assignedTo: string
	visibleTo: string
	tags: string
	description: string
	parentId?: string
}

export const documentsStatusMap:any = []
documentsStatusMap['indexed'] = "Indeksiran"
documentsStatusMap['verified'] = "Verifikovan"
documentsStatusMap['initial'] = "Neindeksiran"
documentsStatusMap['approved'] = "Odobren"
documentsStatusMap['liquidated'] = "Likvidiran"
documentsStatusMap['rejected'] = "Odbijen"
documentsStatusMap['returned'] = "Vraćen"
documentsStatusMap['payed_not-booked'] = "Plaćen, neprokinjižen"
documentsStatusMap['payed_booked'] = "Plaćen, proknjižen"
documentsStatusMap['not-payed_booked'] = "Neplaćen, proknjižen"
documentsStatusMap['processed'] = "Procesiran"
documentsStatusMap['selected_not-booked'] = "Slektovan za plaćanje, neproknjižen"
documentsStatusMap['selected_booked'] = "Slektovan za plaćanje, proknjižen"
